// IA después de los 50 — scripts propios

// Activa animaciones solo si JS está disponible
document.documentElement.classList.add('ia-js');

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initFaq();
  initContador();
  initNotificaciones();
});

function initReveals() {
  var els = document.querySelectorAll('.ia-reveal');
  if (!els.length) return;

  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('ia-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.10 });

  els.forEach(function (el) { obs.observe(el); });
}

function initNotificaciones() {
  var nombres = [
    'María G.', 'Roberto F.', 'Ana C.', 'Carlos M.', 'Patricia L.',
    'Jorge A.', 'Claudia V.', 'Miguel R.', 'Sandra P.', 'Alberto N.',
    'Graciela T.', 'Fernando B.', 'Mónica S.', 'Ricardo D.', 'Liliana E.',
    'Pablo H.', 'Verónica R.', 'Daniel O.', 'Cecilia M.', 'Gustavo P.'
  ];
  var ciudades = [
    'Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata',
    'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén',
    'Santiago de Chile', 'Montevideo', 'Bogotá', 'Lima', 'Ciudad de México'
  ];
  var tiempos = [
    'hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos',
    'hace 9 minutos', 'hace 13 minutos', 'hace 18 minutos',
    'hace 3 minutos', 'hace 7 minutos', 'hace 11 minutos'
  ];

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  var notif = document.createElement('div');
  notif.className = 'ia-notif';
  notif.setAttribute('role', 'status');
  notif.setAttribute('aria-live', 'polite');
  notif.innerHTML =
    '<span class="ia-notif__icono">📚</span>' +
    '<div class="ia-notif__cuerpo">' +
      '<p class="ia-notif__accion"></p>' +
      '<p class="ia-notif__detalle"><span class="ia-notif__punto"></span><span class="ia-notif__tiempo"></span></p>' +
    '</div>' +
    '<button class="ia-notif__cerrar" aria-label="Cerrar notificación">&times;</button>';
  document.body.appendChild(notif);

  var elAccion = notif.querySelector('.ia-notif__accion');
  var elTiempo = notif.querySelector('.ia-notif__tiempo');
  var elCerrar = notif.querySelector('.ia-notif__cerrar');
  var timer;

  function ocultar() {
    clearTimeout(timer);
    notif.classList.remove('ia-notif--visible');
    programarSiguiente();
  }

  function mostrar() {
    elAccion.textContent = pick(nombres) + ' de ' + pick(ciudades) + ' acaba de comprar';
    elTiempo.textContent = pick(tiempos);
    notif.classList.add('ia-notif--visible');
    timer = setTimeout(ocultar, 5500);
  }

  function programarSiguiente() {
    var espera = 40000 + Math.random() * 50000; // 40–90 seg
    setTimeout(mostrar, espera);
  }

  elCerrar.addEventListener('click', ocultar);

  // Primera aparición después de 10 segundos
  setTimeout(mostrar, 10000);
}

function initContador() {
  var timer = document.querySelector('.ia-contador__timer');
  if (!timer) return;

  var elMins = document.getElementById('ia-cnt-mins');
  var elSegs = document.getElementById('ia-cnt-segs');
  if (!elMins || !elSegs) return;

  var minutos  = parseInt(timer.dataset.minutos || '15', 10);
  var duracion = minutos * 60 * 1000;
  var storageKey = 'ia_timer_end';

  var endTime = parseInt(localStorage.getItem(storageKey) || '0', 10);
  if (!endTime || endTime <= Date.now()) {
    endTime = Date.now() + duracion;
    localStorage.setItem(storageKey, endTime);
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick() {
    var diff = endTime - Date.now();
    if (diff <= 0) {
      endTime = Date.now() + duracion;
      localStorage.setItem(storageKey, endTime);
      diff = duracion;
    }

    elMins.textContent = pad(Math.floor(diff / 60000));

    var nuevoSeg = pad(Math.floor((diff % 60000) / 1000));
    if (elSegs.textContent !== nuevoSeg) {
      elSegs.classList.remove('ia-tick');
      elSegs.textContent = nuevoSeg;
      void elSegs.offsetWidth;
      elSegs.classList.add('ia-tick');
    }

    setTimeout(tick, 1000);
  }

  tick();
}

function initFaq() {
  var btns = document.querySelectorAll('.ia-faq-item__btn');
  if (!btns.length) return;

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.ia-faq-item');
      var isOpen = item.classList.contains('ia-open');
      document.querySelectorAll('.ia-faq-item').forEach(function (i) {
        i.classList.remove('ia-open');
      });
      if (!isOpen) item.classList.add('ia-open');
    });
  });
}
